export default __webpack_public_path__ + "static/NBInternationalPro-Mono-ce69eac691d919533c214f144ec8dd86.woff";